import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false, 
  loading: false,
  error: null,
};

const categoriesInitialState = {
  data: [],
  url: null,
  fileLoading: false, 
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const donationListingsReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.DONATION_LISTING_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case actions.DONATION_LISTING_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case actions.DONATION_LISTING_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.DONATION_LISTINGS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.DONATION_LISTINGS_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.DONATION_LISTINGS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.DONATION_LISTING_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.DONATION_LISTING_UPDATE_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.DONATION_LISTING_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const donationListingReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.DONATION_LISTING_READ_BEGIN:
      return {
        ...initialStateSingle,
        loading: true,
      };

    case actions.DONATION_LISTING_READ_SUCCESS:
      return {
        ...initialStateSingle,
        data,
        error: false,
        loading: false,
      };

    case actions.DONATION_LISTING_READ_ERR:
      return {
        ...initialStateSingle,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};


const donationCategoriesReducer = (state = categoriesInitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.CATEGORIES_READ_BEGIN:
      return {
        ...categoriesInitialState,
        loading: true,
      };

    case actions.CATEGORIES_READ_SUCCESS:
      return {
        ...categoriesInitialState,
        data,
        error: false,
        loading: false,
      };

    case actions.CATEGORIES_READ_ERR:
      return {
        ...categoriesInitialState,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { donationListingsReducer, donationListingReducer, donationCategoriesReducer };
